import { memo } from "react";
import { Typography, IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import Popup from "../Popup.js";
import Form from "../Form.js";

const FormPopup = ({
    width = "700px",
    isOpen,
    title,
    titleColor = "black",
    onClose,
    innerText = "",
    onDecline,
    onAccept,
    formContent,
}) => {
    return (
        <Popup
            width={width}
            open={isOpen}
            title={title}
            titleColor={titleColor}
            onClose={onClose}
        >
            <IconButton
                aria-label="close"
                onClick={onDecline}
                sx={{
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon />
            </IconButton>
            <Typography sx={{ color: "dark.main", marginTop: "-1rem", marginBottom: "1rem" }}>
                {innerText}
            </Typography>
            <Form content={formContent} onSubmit={onAccept} toResetForm={false} />
        </Popup>
    );
}

export default memo(FormPopup);
